// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConsultasPremiosPagadosInstantaneos_container__l4nEd {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_header__wR5Yv {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_header__wR5Yv .ConsultasPremiosPagadosInstantaneos_titleContainer__7Ks5h {
  animation: ConsultasPremiosPagadosInstantaneos_toright__q6nWd 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_header__wR5Yv .ConsultasPremiosPagadosInstantaneos_titleContainer__7Ks5h h4 {
  font-size: 2rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_header__wR5Yv .ConsultasPremiosPagadosInstantaneos_arrow__Lqcss {
  transition: 0.5s;
  border-radius: 50%;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_header__wR5Yv .ConsultasPremiosPagadosInstantaneos_arrow__Lqcss:hover {
  cursor: pointer;
  transition: 0.5s;
  scale: 1.1;
  background-color: rgba(34, 34, 34, 0.1);
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_loader__rQnc\\+ {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_data__AkCjR {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

/*---Información---*/
.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_data__AkCjR .ConsultasPremiosPagadosInstantaneos_tableContainer__NCheW {
  animation: ConsultasPremiosPagadosInstantaneos_toleft__H-oxs 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_filters__\\+6zAr {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_filters__\\+6zAr .ConsultasPremiosPagadosInstantaneos_item__li12t {
  animation: ConsultasPremiosPagadosInstantaneos_init__Geu9t 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  margin-right: 10px;
}

.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_filters__\\+6zAr .ConsultasPremiosPagadosInstantaneos_init1__8Gfcu {
  animation: ConsultasPremiosPagadosInstantaneos_init__Geu9t 0.5s 0.2s both;
}
.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_filters__\\+6zAr .ConsultasPremiosPagadosInstantaneos_init2__v-7n\\+ {
  animation: ConsultasPremiosPagadosInstantaneos_init__Geu9t 0.5s 0.4s both;
}
.ConsultasPremiosPagadosInstantaneos_container__l4nEd .ConsultasPremiosPagadosInstantaneos_filters__\\+6zAr .ConsultasPremiosPagadosInstantaneos_init3__oWX6G {
  animation: ConsultasPremiosPagadosInstantaneos_init__Geu9t 0.5s 0.6s both;
}

@keyframes ConsultasPremiosPagadosInstantaneos_init__Geu9t {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes ConsultasPremiosPagadosInstantaneos_toright__q6nWd {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes ConsultasPremiosPagadosInstantaneos_toleft__H-oxs {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ConsultasPremiosPagadosInstantaneos/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kEAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,iEAAsB;EACtB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oEAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yEAA8B;AAChC;AACA;EACE,yEAA8B;AAChC;AACA;EACE,yEAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 2rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .arrow {\n  transition: 0.5s;\n  border-radius: 50%;\n}\n\n.container .header .arrow:hover {\n  cursor: pointer;\n  transition: 0.5s;\n  scale: 1.1;\n  background-color: rgba(34, 34, 34, 0.1);\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: toleft 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .filters .item {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 30px;\n  margin-right: 10px;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n.container .filters .init3 {\n  animation: init 0.5s 0.6s both;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConsultasPremiosPagadosInstantaneos_container__l4nEd`,
	"header": `ConsultasPremiosPagadosInstantaneos_header__wR5Yv`,
	"titleContainer": `ConsultasPremiosPagadosInstantaneos_titleContainer__7Ks5h`,
	"toright": `ConsultasPremiosPagadosInstantaneos_toright__q6nWd`,
	"arrow": `ConsultasPremiosPagadosInstantaneos_arrow__Lqcss`,
	"loader": `ConsultasPremiosPagadosInstantaneos_loader__rQnc+`,
	"data": `ConsultasPremiosPagadosInstantaneos_data__AkCjR`,
	"tableContainer": `ConsultasPremiosPagadosInstantaneos_tableContainer__NCheW`,
	"toleft": `ConsultasPremiosPagadosInstantaneos_toleft__H-oxs`,
	"filters": `ConsultasPremiosPagadosInstantaneos_filters__+6zAr`,
	"item": `ConsultasPremiosPagadosInstantaneos_item__li12t`,
	"init": `ConsultasPremiosPagadosInstantaneos_init__Geu9t`,
	"init1": `ConsultasPremiosPagadosInstantaneos_init1__8Gfcu`,
	"init2": `ConsultasPremiosPagadosInstantaneos_init2__v-7n+`,
	"init3": `ConsultasPremiosPagadosInstantaneos_init3__oWX6G`
};
export default ___CSS_LOADER_EXPORT___;
